'use client';
import { useRouter } from 'next/navigation';
import { FC } from 'react';
import { Pagination } from '@/components/ui';
import useProductListingSearchParams from '@/hooks/use-product-listing-search-params';

type ProductPaginationProps = {
  totalPages: number;
};

const ProductPagination: FC<ProductPaginationProps> = ({ totalPages }) => {
  const router = useRouter();
  const searchParams = useProductListingSearchParams();
  const currentPage = parseInt(searchParams.get('page') ?? '1', 10);

  const handlePageChange = (page: number) => {
    const newSearchParams = new URLSearchParams(window.location.search);
    newSearchParams.set('page', page.toString());
    const query = newSearchParams.toString();
    const pathname = window.location.pathname;
    router.push(query ? `${pathname}?${query}` : pathname);
  };

  return (
    <Pagination
      data-testid="product-pagination__pagination"
      total={totalPages}
      page={currentPage}
      onChange={handlePageChange}
    />
  );
};

export default ProductPagination;
